<template>
	<div class="dp" :style="{ paddingTop: (data.basics.marginTop || 0) + 'px', paddingRight: (data.basics.marginRight || 0) + 'px', paddingBottom: (data.basics.marginBottom || 0) + 'px', paddingLeft: (data.basics.marginLeft || 0) + 'px', backgroundColor: '#fff', height: 'calc(100vh + ' + 50 / data.basics.scaleFactor + 'vh)' }">
		<div v-if="difference2 == '过期'" class="dqtx">
			<div>
				<p v-if="data.basics.expireFlag">您的软件已经过期{{ timeDifference ? timeDifference : "超过一周啦" }}</p>
				<p v-if="!data.basics.status && !data.basics.expireFlag">您的软件已被禁用</p>
				<p>请及时联系您的业务员或拨打电话进行续费</p>
				<p>
					服务热线：
					<a href="13267110818">13267110818</a>
				</p>
			</div>
		</div>
		<!-- 水印 -->
		<WaterMarks v-if="data.basics.waterMarkFlag" />
		<FloatingWindow v-if="timeDifference" width="300px" height="85px">
			<p>中威软件温馨提示：</p>
			<p style="text-align: left">
				您的软件将在
				<a style="color: #ee4073">{{ timeDifference }}</a>
				后到期，请及时续费,以免影响您的正常使用！
			</p>
		</FloatingWindow>
		<notPage v-if="data.notPages" />
		<div class="dp-title" :style="{ top: data.basics.marginTop + 'px' }">
			<img style="height: 100%; width: auto" :src="data.basics.logoUrl" />
			<div style="width: 100%">
				<div style="display: inline-block">
					<div class="dp-title-item" style="display: flex; justify-content: space-between">
						<div :style="{ color: data.basics.titleColor || '' }" v-for="item in data.basics.headCn" :key="item">{{ item }}</div>
					</div>
					<div class="dp-title-item2" style="display: flex; justify-content: space-between; margin: 0 5px">
						<div :style="{ color: data.basics.titleColor || '' }" v-for="item in data.basics.headEn" :key="item">{{ item }}</div>
					</div>
				</div>
			</div>
			<!-- 时间 -->
			<div class="dp-hq-time">
				{{ data.time }}
				<!-- {{ data.time.slice(0,10) }} -->

				<!-- <div >{{ data.time.slice(11,20) }}</div> -->
				<!-- <span style="margin-left: 20px">开盘</span> -->
			</div>
			<img style="height: 100%; width: auto; padding: 2px" :src="data.basics.barcodeUrl" />
		</div>
		<div class="dp-conter" :style="{ height: 'calc(100vh + ' + 50 / data.basics.scaleFactor + 'vh)' }">
			<!-- 行情 -->
			<div v-show="data.tabbarHover == 0" class="dp-hq">
				<!-- <div class="dp-hq-pmd" :style="{ backgroundColor: data.basics.backGroundColor || 'rgb(0,0,0)' }">
					<marquee class="marqueee" :style="getTextColorByBg(data.basics.backGroundColor || 'rgb(0,0,0)') == '#000' ? 'color:#000' : 'color: #EE4073'" v-if="data.basics.headRollFlag" scrollamount="5" loop="loop">{{ data.basics.headRollDesc }}</marquee>
					<div v-show="!data.basics.headRollFlag" style="color: #ee4073; text-align: center; overflow-x: scroll; white-space: nowrap">{{ data.basics.headRollDesc }}</div>
				</div> -->
				<div style="display: flex; align-items: flex-start; border-top: 4px solid #e1ba69">
					<div :style="!isMobileDevice && data.basics.splitScreenFlag ? 'width: 50%' : 'width:100%'">
						<div class="dp-hq-header" :style="{ paddingLeft: data.basics.showGroupFlag ? (data.basics.groupNamePosition == 'left' ? (!isMobileDevice ? '74px' : '40px') : '') : '' }">
							<div v-for="(item, index) in data.hqHeader" :key="index">{{ item }}</div>
						</div>
						<div class="dp-hq-conter" :style="{ height: 'calc(100vh - 250px + ' + 50 / data.basics.scaleFactor + 'vh)' }">
							<!-- 分组模式 -->
							<template v-if="data.basics.showGroupFlag">
								<template v-for="(groupItems, groupName) in groupedData.left || groupedData" :key="groupName">
									<div class="dp-hq-group" style="align-items: stretch" :style="data.basics.groupNamePosition == 'left' ? 'display: flex' : ''">
										<!-- 左侧分组名 -->
										<div
											v-if="data.basics.groupNamePosition == 'left' || data.basics.splitScreenFlag || groupName != Object.keys(groupedData.left || groupedData)[0]"
											class="group-label"
											style="border-bottom: 2px solid #fff"
											:style="{
												borderRight: data.basics.groupNamePosition == 'left' ? '1px solid' : '',
												backgroundColor: adjustGrayscaleRgb(data.basics.backGroundColor || 'rgb(0,0,0)'),
												color: getTextColorByBg(data.basics.backGroundColor || 'rgb(0,0,0)'),
												borderColor: getTextColorByBg(data.basics.backGroundColor || 'rgb(0,0,0)') == '#000' ? '#d8d8d8' : '#858585',
												width: data.basics.groupNamePosition === 'left' ? '' : '100%',
												writingMode: data.basics.groupNamePosition === 'left' ? '' : 'lr'
											}"
										>
											{{ groupName || "未分组" }}
										</div>
										<!-- 右侧数据 -->
										<div style="flex: 1; border-bottom: 2px solid #757575">
											<div class="dp-hq-item" v-for="(item, index) in groupItems" :key="index" :style="index % 2 == 0 ? 'background:' + adjustGrayscaleRgb(data.basics.backGroundColor || 'rgb(0,0,0)') : ''">
												<div class="good-name" :style="getTextColorByBg(data.basics.backGroundColor || 'rgb(0,0,0)') == '#000' ? 'color:#000' : 'color: #ffbf24'">{{ item.productName }}</div>
												<div style="position: relative; border-right: 1px solid #ccc" :class="data.basics.isSwitch == 1 ? item.backColor : ''" :style="item.highPrice == item.lowPrice ? 'color:' + getTextColorByBg(data.basics.backGroundColor || 'rgb(0,0,0)') : item.backPrice > item.yesyBackPrice ? 'color:' + data.basics.upColor : 'color:' + data.basics.downColor">
													<i class="jiantou" style="transform: rotate(-90deg); font-style: normal" v-if="data.basics.isSwitch == 2" :style="'color:' + (item.backColor == 'red' ? 'red !important' : 'transparent !important')">➜</i>
													<i class="jiantou" style="transform: rotate(90deg); font-style: normal" v-if="data.basics.isSwitch == 2" :style="'color:' + (item.backColor == 'green' ? 'green !important' : 'transparent !important')">➜</i>
													{{ item.backPrice || "——" }}
												</div>
												<div style="position: relative; border-right: 1px solid #ccc" :class="data.basics.isSwitch == 1 ? item.saleColor : ''" :style="item.highPrice == item.lowPrice ? 'color:' + getTextColorByBg(data.basics.backGroundColor || 'rgb(0,0,0)') : item.salePrice > item.yesySalePrice ? 'color:' + data.basics.upColor : 'color:' + data.basics.downColor">
													<i class="jiantou" style="transform: rotate(-90deg); font-style: normal" v-if="data.basics.isSwitch == 2" :style="'color:' + (item.saleColor == 'red' ? 'red !important' : 'transparent !important')">➜</i>
													<i class="jiantou" style="transform: rotate(90deg); font-style: normal" v-if="data.basics.isSwitch == 2" :style="'color:' + (item.saleColor == 'green' ? 'green !important' : 'transparent !important')">➜</i>
													{{ item.salePrice || "——" }}
												</div>
												<div class="gd" :style="'color:' + data.basics.upColor">
													{{ item.highPrice || "——" }}
													<div :style="'color:' + data.basics.downColor">{{ item.lowPrice || "——" }}</div>
												</div>
											</div>
										</div>
									</div>
								</template>
							</template>

							<!-- 非分组模式 -->
							<template v-else>
								<div class="dp-hq-item" v-for="(item, index) in data.hqConter" :key="index" :style="index % 2 == 0 ? 'background:' + adjustGrayscaleRgb(data.basics.backGroundColor || 'rgb(0,0,0)') : ''">
									<div class="good-name" :style="getTextColorByBg(data.basics.backGroundColor || 'rgb(0,0,0)') == '#000' ? 'color:#000' : 'color: #ffbf24'" style="color: #ffbf24; position: relative">{{ item.productName }}</div>
									<div style="position: relative; border-right: 1px solid #ccc" :class="data.basics.isSwitch == 1 ? item.backColor : ''" :style="item.highPrice == item.lowPrice ? 'color:' + getTextColorByBg(data.basics.backGroundColor || 'rgb(0,0,0)') : item.backPrice > item.yesyBackPrice ? 'color:' + data.basics.upColor : 'color:' + data.basics.downColor">
										<i class="jiantou" style="transform: rotate(-90deg); font-style: normal" v-if="data.basics.isSwitch == 2" :style="'color:' + (item.backColor == 'red' ? 'red !important' : 'transparent !important')">➜</i>
										<i class="jiantou" style="transform: rotate(90deg); font-style: normal" v-if="data.basics.isSwitch == 2" :style="'color:' + (item.backColor == 'green' ? 'green !important' : 'transparent !important')">➜</i>
										{{ !item.hideLine ? item.backPrice || "——" : "" }}
									</div>
									<div style="position: relative; border-right: 1px solid #ccc" :class="data.basics.isSwitch == 1 ? item.saleColor : ''" :style="item.highPrice == item.lowPrice ? 'color:' + getTextColorByBg(data.basics.backGroundColor || 'rgb(0,0,0)') : item.salePrice > item.yesySalePrice ? 'color:' + data.basics.upColor : 'color:' + data.basics.downColor">
										<i class="jiantou" style="transform: rotate(-90deg); font-style: normal" v-if="data.basics.isSwitch == 2" :style="'color:' + (item.saleColor == 'red' ? 'red !important' : 'transparent !important')">➜</i>
										<i class="jiantou" style="transform: rotate(90deg); font-style: normal" v-if="data.basics.isSwitch == 2" :style="'color:' + (item.saleColor == 'green' ? 'green !important' : 'transparent !important')">➜</i>
										{{ !item.hideLine ? item.salePrice || "——" : "" }}
									</div>
									<div class="gd" :style="'color:' + data.basics.upColor">
										{{ !item.hideLine ? item.highPrice || "——" : "" }}
										<div :style="'color:' + data.basics.downColor">{{ !item.hideLine ? item.lowPrice || "——" : "" }}</div>
									</div>
								</div>
							</template>

							<!-- 公共底部信息 -->
							<div class="msg" v-show="data.basics" :style="data.tenantId == 'MHDD' ? 'padding-left:40px' : ''">
								<div v-if="data.basics.disclaimers" style="color: red">免责声明：{{ data.basics.disclaimers }}</div>
								<div v-if="data.basics.hotline" :style="{ color: getTextColorByBg(data.basics.backGroundColor || 'rgb(0,0,0)') }">
									热线：
									<a :href="'tel:' + data.basics.hotline">{{ data.basics.hotline }}</a>
								</div>
								<div v-if="data.basics.company" :style="{ color: getTextColorByBg(data.basics.backGroundColor || 'rgb(0,0,0)') }" style="display: flex">
									<span style="flex-shrink: 0">摘要：</span>
									{{ data.basics.company }}
								</div>
								<div v-for="item in data.basics.addressList" :key="item" :style="{ color: getTextColorByBg(data.basics.backGroundColor || 'rgb(0,0,0)') }">地址：{{ item }}</div>
								<div v-if="data.basics.officialWebsite" :style="{ color: getTextColorByBg(data.basics.backGroundColor || 'rgb(0,0,0)') }">
									官网：
									<a :href="data.basics.officialWebsite">{{ data.basics.officialWebsite }}</a>
								</div>
								<div v-if="data.basics.recordNumber" :style="{ color: getTextColorByBg(data.basics.backGroundColor || 'rgb(0,0,0)') }">备案号：{{ data.basics.recordNumber }}</div>
							</div>

							<div class="jszc" :style="{ color: getTextColorByBg(data.basics.backGroundColor || 'rgb(0,0,0)') }">
								<a href="http://www.szzwei.cn/">技术支持 中威软件-13267110818</a>
							</div>
						</div>
					</div>
					<div v-if="!isMobileDevice && data.basics.splitScreenFlag" style="width: 50%" :style="{ borderLeft: data.basics.groupNamePosition == 'top' ? '1px solid' : '', borderColor: getTextColorByBg(data.basics.backGroundColor || 'rgb(0,0,0)') == '#000' ? '#d8d8d8' : '#858585' }">
						<div class="dp-hq-header" :style="{ paddingLeft: data.basics.showGroupFlag ? (data.basics.groupNamePosition == 'left' ? (!isMobileDevice ? '74px' : '40px') : '') : '' }">
							<div v-for="(item, index) in data.hqHeader" :key="index">{{ item }}</div>
						</div>
						<div class="dp-hq-conter" :style="{ height: 'calc(100vh - 250px + ' + 50 / data.basics.scaleFactor + 'vh)' }">
							<!-- 分组模式 -->
							<template v-if="data.basics.showGroupFlag">
								<template v-for="(groupItems, groupName) in groupedData.right || groupedData" :key="groupName">
									<div class="dp-hq-group" style="align-items: stretch" :style="data.basics.groupNamePosition == 'left' ? 'display: flex' : ''">
										<!-- 左侧分组名 -->
										<div
											v-if="data.basics.groupNamePosition == 'left' || data.basics.splitScreenFlag || groupName != '国内行情'"
											class="group-label"
											style="border-bottom: 2px solid #fff"
											:style="{
												borderLeft: data.basics.groupNamePosition == 'left' ? '1px solid' : '',
												borderRight: data.basics.groupNamePosition == 'left' ? '1px solid' : '',
												backgroundColor: adjustGrayscaleRgb(data.basics.backGroundColor || 'rgb(0,0,0)'),
												color: getTextColorByBg(data.basics.backGroundColor || 'rgb(0,0,0)'),
												borderColor: getTextColorByBg(data.basics.backGroundColor || 'rgb(0,0,0)') == '#000' ? '#d8d8d8' : '#858585',
												width: data.basics.groupNamePosition === 'left' ? '' : '100%',
												writingMode: data.basics.groupNamePosition === 'left' ? '' : 'lr'
											}"
										>
											<template v-if="!groupedData.left[groupName] || groupedData.left[groupName].length === 0">
												{{ groupName || "未分组" }}
											</template>
											<template v-else>&nbsp;</template>
										</div>
										<!-- 右侧数据 -->
										<div style="flex: 1; border-bottom: 2px solid #757575">
											<div class="dp-hq-item" v-for="(item, index) in groupItems" :key="index" :style="index % 2 == 0 ? 'background:' + adjustGrayscaleRgb(data.basics.backGroundColor || 'rgb(0,0,0)') : ''">
												<div class="good-name" :style="getTextColorByBg(data.basics.backGroundColor || 'rgb(0,0,0)') == '#000' ? 'color:#000' : 'color: #ffbf24'">{{ item.productName }}</div>
												<div style="position: relative; border-right: 1px solid #ccc" :class="data.basics.isSwitch == 1 ? item.backColor : ''" :style="item.highPrice == item.lowPrice ? 'color:' + getTextColorByBg(data.basics.backGroundColor || 'rgb(0,0,0)') : item.backPrice > item.yesyBackPrice ? 'color:' + data.basics.upColor : 'color:' + data.basics.downColor">
													<i class="jiantou" style="transform: rotate(-90deg); font-style: normal" v-if="data.basics.isSwitch == 2" :style="'color:' + (item.backColor == 'red' ? 'red !important' : 'transparent !important')">➜</i>
													<i class="jiantou" style="transform: rotate(90deg); font-style: normal" v-if="data.basics.isSwitch == 2" :style="'color:' + (item.backColor == 'green' ? 'green !important' : 'transparent !important')">➜</i>
													{{ !item.hideLine ? item.backPrice || "——" : "" }}
												</div>
												<div style="position: relative; border-right: 1px solid #ccc" :class="data.basics.isSwitch == 1 ? item.saleColor : ''" :style="item.highPrice == item.lowPrice ? 'color:' + getTextColorByBg(data.basics.backGroundColor || 'rgb(0,0,0)') : item.salePrice > item.yesySalePrice ? 'color:' + data.basics.upColor : 'color:' + data.basics.downColor">
													<i class="jiantou" style="transform: rotate(-90deg); font-style: normal" v-if="data.basics.isSwitch == 2" :style="'color:' + (item.saleColor == 'red' ? 'red !important' : 'transparent !important')">➜</i>
													<i class="jiantou" style="transform: rotate(90deg); font-style: normal" v-if="data.basics.isSwitch == 2" :style="'color:' + (item.saleColor == 'green' ? 'green !important' : 'transparent !important')">➜</i>
													{{ !item.hideLine ? item.salePrice || "——" : "" }}
												</div>
												<div class="gd" :style="'color:' + data.basics.upColor">
													{{ !item.hideLine ? item.highPrice || "——" : "" }}
													<div :style="'color:' + data.basics.downColor">{{ !item.hideLine ? item.lowPrice || "——" : "" }}</div>
												</div>
											</div>
										</div>
									</div>
								</template>
							</template>
							<!-- 非分组模式 -->
							<template v-else>
								<div class="dp-hq-item" v-for="(item, index) in data.hqConter" :key="index" :style="index % 2 == 0 ? 'background:' + adjustGrayscaleRgb(data.basics.backGroundColor || 'rgb(0,0,0)') : ''">
									<div class="good-name" :style="getTextColorByBg(data.basics.backGroundColor || 'rgb(0,0,0)') == '#000' ? 'color:#000' : 'color: #ffbf24'" style="color: #ffbf24; position: relative">{{ item.productName }}</div>
									<div style="position: relative; border-right: 1px solid #ccc" :class="data.basics.isSwitch == 1 ? item.backColor : ''" :style="item.highPrice == item.lowPrice ? 'color:' + getTextColorByBg(data.basics.backGroundColor || 'rgb(0,0,0)') : item.backPrice > item.yesyBackPrice ? 'color:' + data.basics.upColor : 'color:' + data.basics.downColor">
										<i class="jiantou" style="transform: rotate(-90deg); font-style: normal" v-if="data.basics.isSwitch == 2" :style="'color:' + (item.backColor == 'red' ? 'red !important' : 'transparent !important')">➜</i>
										<i class="jiantou" style="transform: rotate(90deg); font-style: normal" v-if="data.basics.isSwitch == 2" :style="'color:' + (item.backColor == 'green' ? 'green !important' : 'transparent !important')">➜</i>
										{{ item.backPrice || "——" }}
									</div>
									<div style="position: relative; border-right: 1px solid #ccc" :class="data.basics.isSwitch == 1 ? item.saleColor : ''" :style="item.highPrice == item.lowPrice ? 'color:' + getTextColorByBg(data.basics.backGroundColor || 'rgb(0,0,0)') : item.salePrice > item.yesySalePrice ? 'color:' + data.basics.upColor : 'color:' + data.basics.downColor">
										<i class="jiantou" style="transform: rotate(-90deg); font-style: normal" v-if="data.basics.isSwitch == 2" :style="'color:' + (item.saleColor == 'red' ? 'red !important' : 'transparent !important')">➜</i>
										<i class="jiantou" style="transform: rotate(90deg); font-style: normal" v-if="data.basics.isSwitch == 2" :style="'color:' + (item.saleColor == 'green' ? 'green !important' : 'transparent !important')">➜</i>
										{{ item.salePrice || "——" }}
									</div>
									<div class="gd" :style="'color:' + data.basics.upColor">
										{{ item.highPrice || "——" }}
										<div :style="'color:' + data.basics.downColor">{{ item.lowPrice || "——" }}</div>
									</div>
								</div>
							</template>
							<div class="jszc" :style="{ color: getTextColorByBg(data.basics.backGroundColor || 'rgb(0,0,0)') }">
								<a href="http://www.szzwei.cn/">技术支持 中威软件-13267110818</a>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 基差 -->
			<div v-show="data.tabbarHover == 1" class="dp-jc">
				<div class="dp-hq-pmd" :style="{ backgroundColor: data.basics.backGroundColor || 'rgb(0,0,0)' }">
					<div class="dp-hq-time">{{ data.time }}{{ data.basics.openFlag ? "开盘" : "停盘" }}</div>
				</div>
				<div class="dp-hq-header">
					<div v-for="(item, index) in data.hqHeader" :key="index">{{ item }}</div>
				</div>
				<div class="dp-hq-conter" :style="{ height: 'calc(100vh - 250px + (100vh - 250px) / ' + data.basics.scaleFactor + ')' }">
					<div v-for="(item, index) in data.jxConter" :key="index">
						<div style="background: #d7a94b; text-align: center; padding: 5px 0; color: #fff; font-weight: bold; font-size: 18px">{{ item.groupName }}</div>
						<div class="dp-hq-item" :style="indexs % 2 == 0 ? 'background:' + adjustGrayscaleRgb(data.basics.backGroundColor || 'rgb(0,0,0)') : ''" v-for="(items, indexs) in item.basisList" :key="indexs">
							<div style="color: #ffbf24">{{ items.productName }}</div>
							<div>{{ items.buyPrice || "——" }}</div>
							<div>{{ items.salePrice || "——" }}</div>
							<div>{{ items.basisValue || "——" }}</div>
						</div>
					</div>
					<div class="msg">
						<div style="color: #ee4073">声明：{{ data.basics.basisStatement }}</div>
					</div>
				</div>
			</div>
			<!-- 资讯 -->
			<div v-show="data.tabbarHover == 2" class="dp-zx" :style="{ height: 'calc(100vh - 250px + (100vh - 250px) / ' + data.basics.scaleFactor + ')' }">
				<iframe v-if="data.isMobile" width="100%" height="100%" src="https://www.sge.com.cn/h5_news/sjsgg"></iframe>

				<iframe v-else width="100%" height="100%" src="https://www.sge.com.cn/jjsnotice"></iframe>
			</div>
			<!-- 财经 -->
			<div v-show="data.tabbarHover == 3" class="dp-cj" :style="{ height: 'calc(100vh - 250px + (100vh - 250px) / ' + data.basics.scaleFactor + ')' }">
				<iframe width="100%" height="100%" src="https://www.fecn.net/finance/"></iframe>
			</div>
		</div>
		<!-- tabbar -->
		<div class="dp-tabbar" :style="{ backgroundColor: adjustGrayscaleRgb(data.basics.backGroundColor || 'rgb(0,0,0)'), borderColor: getTextColorByBg(data.basics.backGroundColor || 'rgb(0,0,0)'), color: getTextColorByBg(data.basics.backGroundColor || 'rgb(0,0,0)') }">
			<div v-if="data.basics.marketShowFlag" @click="changeTabbar(0)" :style="data.tabbarHover == 0 ? 'background:' + data.basics.backGroundColor : ''" class="dp-item">行情</div>
			<div v-if="data.basics.basisShowFlag" @click="changeTabbar(1)" :style="data.tabbarHover == 1 ? 'background:' + data.basics.backGroundColor : ''" class="dp-item">基差</div>
			<div v-if="data.basics.newsShowFlag" @click="changeTabbar(2)" :style="data.tabbarHover == 2 ? 'background:' + data.basics.backGroundColor : ''" class="dp-item">资讯</div>
			<div v-if="data.basics.financeShowFlag" @click="changeTabbar(3)" :style="data.tabbarHover == 3 ? 'background:' + data.basics.backGroundColor : ''" class="dp-item">财经</div>
		</div>
		<div v-if="!isMobileDevice" style="color: #fff; position: fixed; bottom: 0; right: 0; display: flex; z-index: 999999; transform: scale(0.8); text-align: right" :style="'zoom:' + 1 / data.basics.scaleFactor">
			<div style="background: #000; cursor: pointer; border: 1px solid #fff; padding: 1px 6px; border-radius: 5px" @click="changeSize('reduce')">缩小</div>
			<div style="background: #000; cursor: pointer; border: 1px solid #fff; margin-left: 10px; padding: 1px 6px; border-radius: 5px" @click="changeSize('increase')">放大</div>
		</div>
	</div>
</template>
<script setup>
// import screenfull from 'screenfull';
import { ref, onMounted, onUnmounted, getCurrentInstance, computed } from "vue";
import api from "@/api/http";
import WaterMarks from "@/components/WaterMarks.vue";
import FloatingWindow from "@/components/FloatingWindow.vue";
import notPage from "@/components/notPage.vue";
import useTimeDifference from "@/composables/useTimeDifference.js";
const { proxy } = getCurrentInstance();
const { calculateTimeDifference, timeDifference, difference2 } = useTimeDifference(); //判断本地时间和服务器时间
// calculateTimeDifference,
const data = ref({
	isMobile: false,
	color: "#000000",
	time: "",
	notPages: false,
	count: 0,
	tabbarHover: 0,
	tabbar: [{ name: "行情" }, { name: "基差" }, { name: "资讯" }, { name: "财经" }],
	hqHeader: ["商 品", "回 购", "销 售", "高 / 低"],
	hqConter: [],
	jxConter: [],
	tenantId: "",
	notleftRightFlag: false,
	basics: {}
});
let timerId;
let timerId2;
let timerId3;
const formatDate = date => {
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, "0");
	const day = String(date.getDate()).padStart(2, "0");
	const hours = String(date.getHours()).padStart(2, "0");
	const minutes = String(date.getMinutes()).padStart(2, "0");
	const seconds = String(date.getSeconds()).padStart(2, "0");
	// return `${year}年${month}月${day}日 ${hours}:${minutes}:${seconds}`;
	return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
};
const changeSize = (type = "reduce") => {
	if (type == "reduce") {
		data.value.basics.scaleFactor = data.value.basics.scaleFactor - 0.1;
	} else if (type == "increase") {
		data.value.basics.scaleFactor = data.value.basics.scaleFactor + 0.1;
	}
	if (!isMobileDevice.value) document.body.style.zoom = data.value.basics.scaleFactor;
};
// 定义增加计数的函数
const updateTime = () => {
	// 获取当前时间
	data.value.time = formatDate(new Date());
	//行情
};
const isMobileDevice = ref(false);

function checkScreenWidth() {
	isMobileDevice.value = window.innerWidth <= 768;
}
const groupedData = computed(() => {
	const groups = {};
	(data.value.hqConter || []).forEach(item => {
		const key = item.groupName || "未分组";
		if (!groups[key]) {
			groups[key] = [];
		}
		groups[key].push(item);
	});
	if (isMobileDevice.value || !data.value.basics.splitScreenFlag) return groups;
	// return groups;
	// 进行左右列分配（平衡）
	const groupEntries = Object.entries(groups); // 保证顺序
	const totalCount = groupEntries.reduce((sum, [_, items]) => sum + items.length, 0);
	const targetLeftCount = Math.ceil(totalCount / 2);

	const left = {};
	const right = {};
	let leftCount = 0;

	for (const [groupName, items] of groupEntries) {
		const groupLength = items.length;

		if (leftCount + groupLength <= targetLeftCount) {
			// 整组放左边
			left[groupName] = items;
			leftCount += groupLength;
		} else if (leftCount < targetLeftCount) {
			// 拆分组
			const take = targetLeftCount - leftCount;
			left[groupName] = items.slice(0, take);
			right[groupName] = items.slice(take);
			leftCount += take;
		} else {
			// 整组放右边
			right[groupName] = items;
		}
	}
	return { left, right };
});
const getTextColorByBg = rgbString => {
	// 提取 r、g、b 数值
	const match = rgbString.match(/\d+/g);
	if (!match || match.length < 3) return "#000"; // 默认黑色

	const [r, g, b] = match.map(Number);

	// 计算相对亮度（加权平均法）
	const brightness = 0.299 * r + 0.587 * g + 0.114 * b;

	// 阈值可调，通常 128 或 186
	return brightness > 186 ? "#000" : "#fff";
};
const updateTime3 = () => {
	//基础数据
	api.get("/metalMarket/sysTenantBoardConf/getByWebUrl/" + data.value.tenantId).then(response => {
		if (response.data) {
			//  updateTime2();

			if (data.value.basics) {
				if (data.value.basics.scaleFactor != response.data.scaleFactor) {
					if (!isMobileDevice.value) document.body.style.zoom = response.data.scaleFactor;
					// document.html.style.transform = 'scale('+response.data.scaleFactor+')';
				}
			} else {
				if (!isMobileDevice.value) document.body.style.zoom = response.data.scaleFactor;

				// document.html.style.transform = 'scale('+response.data.scaleFactor+')';
			}
			data.value.basics = response.data; // 处理响应数据
			let link = document.querySelector("link[rel~='icon']");
			if (!link) {
				link = document.createElement("link");
				link.rel = "icon";
				document.head.appendChild(link);
			}
			link.href = data.value.basics.shareLogoUrl;
			if (data.value.notleftRightFlag) data.value.basics.splitScreenFlag = false;

			if (data.value.basics.expireFlag || !data.value.basics.status) {
				difference2.value = "过期";
				clearInterval(timerId2);
				clearInterval(timerId3);
			}
			if (data.value.hqConter.length) return;
			// websocket链接
			const socket = new WebSocket(proxy.$globalConfig.wsURL);
			// 监听连接打开
			socket.addEventListener("open", () => {
				console.log("WebSocket连接成功");
				// 发送请求
				const requestData = { msgType: "url", data: data.value.tenantId };
				socket.send(JSON.stringify(requestData));
			});
			// 监听消息
			socket.addEventListener("message", event => {
				let contrastData = data.value.hqConter;
				const response = JSON.parse(event.data);
				if (new Date(data.value.basics.usageTime[0]).getTime() > new Date().getTime()) {
					data.value.hqConter = [];
					data.value.jxConter = [];
					clearInterval(timerId2);
					clearInterval(timerId3);
					return;
				}
				if (response.length >= 1 && response[0].productName) {
					data.value.hqConter = response; // 处理响应数据
					if (!isMobileDevice.value) {
						if (data.value.hqConter.length % 2 === 1) {
							const lastItem = data.value.hqConter[data.value.hqConter.length - 1];
							const groupName = lastItem.groupName || "";
							if (data.value.basics.splitScreenFlag) {
								// 插入一条新数据，带上相同的 groupName
								data.value.hqConter.push({
									groupName: groupName,
									hideLine: true,
									backPrice: 0,
									salePrice: 0
									// 可添加其他默认字段
								});
							}
						}
					}

					data.value.hqConter.forEach(item => {
						if (item.groupName == "香港永丰") item.groupName = "国际行情";
					});
					calculateTimeDifference(new Date(data.value.basics.usageTime[1]).getTime(), Number(response[0].currentTime));
					if (contrastData.length && data.value.basics.isSwitch) {
						// && data.value.basics.isSwitch
						data.value.hqConter.forEach((item, index) => {
							// 清除已有的定时器
							if (item.backTimer) {
								clearTimeout(item.backTimer);
							}
							if (item.saleTimer) {
								clearTimeout(item.saleTimer);
							}
							if (item.backPrice > contrastData[index].backPrice) {
								//判断涨//并且比上一次高
								item.backColor = "red";
								item.backTimer = setTimeout(() => {
									item.backColor = "";
								}, 1000);
							}
							if (item.backPrice < contrastData[index].backPrice) {
								//判断涨//并且比上一次高
								item.backColor = "green";
								item.backTimer = setTimeout(() => {
									item.backColor = "";
								}, 1000);
							}
							//判断销售数据
							if (item.salePrice > contrastData[index].salePrice) {
								//判断涨//并且比上一次高
								item.saleColor = "red";
								item.saleTimer = setTimeout(() => {
									item.saleColor = "";
								}, 1000);
							}
							if (item.salePrice < contrastData[index].salePrice) {
								//判断涨//并且比上一次高
								item.saleColor = "green";
								item.saleTimer = setTimeout(() => {
									item.saleColor = "";
								}, 1000);
							}
						});
					}
				}
				// 处理返回的消息数据
			});

			// 监听错误
			socket.addEventListener("error", error => {
				console.error("WebSocket连接错误:", error);
			});

			// 监听连接关闭
			socket.addEventListener("close", () => {
				console.log("WebSocket连接关闭,开始重连");
				data.value.hqConter = [];
				updateTime3();
			});
		} else {
			clearInterval(timerId3);
		}
	});
};
//切换tabbar
const changeTabbar = index => {
	data.value.tabbarHover = index;
};
//计算灰度值
function adjustGrayscaleRgb(rgb, factor = getTextColorByBg(rgb) == "#000" ? 0.4 : 0.1) {
	if (!rgb || typeof rgb !== "string") {
		throw new Error("Invalid RGB value");
	}

	// 解析 RGB 值
	const rgbArray = rgb.match(/\d+/g);

	if (!rgbArray || rgbArray.length !== 3) {
		throw new Error("Invalid RGB format");
	}

	let [r, g, b] = rgbArray.map(Number);

	// 混合白色
	r = Math.round(r + (255 - r) * factor);
	g = Math.round(g + (255 - g) * factor);
	b = Math.round(b + (255 - b) * factor);

	// 返回调整后的 RGB 字符串
	return `rgb(${r}, ${g}, ${b})`;
}
function loadWeixinScript() {
	//加载微信sdk
	return new Promise((resolve, reject) => {
		const script = document.createElement("script");
		script.src = "https://res.wx.qq.com/open/js/jweixin-1.4.0.js";
		script.onload = () => resolve();
		script.onerror = () => reject(new Error("Weixin script load error"));
		document.head.appendChild(script);
	});
}
const initializeWeixinSDK = config => {
	const wx = window.wx; // 确保 wx 是从 window 对象中获取
	const wxConfig = {
		debug: false,
		appId: config.appId,
		timestamp: config.timestamp,
		nonceStr: config.nonceStr,
		signature: config.signature,
		jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage"]
	};
	wx.config(wxConfig);
	wx.ready(() => {
		const timestamp = new Date().getTime(); // 获取当前时间戳
		const imageUrlWithTimestamp = `${data.value.basics.shareLogoUrl}?t=${timestamp}`;
		// 微信SDK初始化成功后的回调
		wx.onMenuShareTimeline({
			//朋友圈
			title: data.value.basics.logoDesc,
			link: window.location.href,
			imgUrl: imageUrlWithTimestamp,
			success: function () {
				// 用户确认分享后执行的回调函数
			},
			cancel: function () {
				// 用户取消分享后执行的回调函数
			}
		});

		wx.onMenuShareAppMessage({
			//pengyop
			title: data.value.basics.logoDesc,
			desc: data.value.basics.shareDesc,
			link: window.location.href,
			imgUrl: imageUrlWithTimestamp,
			success: function () {
				// 用户确认分享后执行的回调函数
			},
			cancel: function (err) {
				// 用户取消分享后执行的回调函数
			}
		});
	});

	wx.error(function (res) {
		console.error("Weixin config error:", res);
	});
};
async function getWeixinConfig(url) {
	try {
		const response = await api.get("/metalMarket/sysTenantBoardConf/getWxJsConfig?url=" + url);
		return response.data;
	} catch (error) {
		console.error("Error fetching Weixin config:", error);
		throw error;
	}
}

onMounted(async () => {
	console.log("jinlaile");
	checkScreenWidth();
	window.addEventListener("resize", checkScreenWidth);
	await loadWeixinScript();
	// const url = window.location.href.split("#")[0]; // 当前页面的URL
	const url = window.location.href; // 获取当前页面的完整 URL
	const config = await getWeixinConfig(url);
	if (config) initializeWeixinSDK(config);

	const urlParams = new URLSearchParams(window.location.search);
	data.value.tenantId = urlParams.get("v");
	data.value.notleftRightFlag = urlParams.get("lr");

	updateTime3();
	timerId = setInterval(updateTime, 500); //右上角时间
	// timerId2 = setInterval(updateTime2, 1000);//行情信息
	timerId3 = setInterval(updateTime3, 120000); //基本信息

	// //基差
	api.get("/metalMarket/board/listBasis/" + data.value.tenantId).then(response => {
		data.value.jxConter = response.data; // 处理响应数据
	});
});
//基础信息

onUnmounted(() => {
	clearInterval(timerId);
	clearInterval(timerId2);
});
</script>
<script>
export default {
	name: "homeDP"
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.jiantou {
	position: absolute;
	margin-left: -25px;
	font-size: 20px;
}
.group-label {
	background: #8f3024 !important;
	color: #fff !important;
	padding: 4px 8px;
	/* border-right: 1px solid #fff; */
	writing-mode: vertical-lr;
	text-align: center;
	/* font-weight: bold; */
	font-size: 34px;
	letter-spacing: 8px;
	display: flex;
	align-items: center;
	justify-content: center;
}
.red {
	background: red;
	color: #fff !important;
}
.green {
	background: green;
	color: #fff !important;
}

html {
	background: rgb(42, 52, 58);
}
.gd {
	font-size: 28px;
	line-height: 24px !important;
	padding-top: 14px;
	font-weight: bold;
}
.phone_icon {
	/* display: none; */
}
.dp {
	position: relative;
	overflow: hidden;
	/* background: #000000; */
	color: #fff;
	width: 100%;
	height: 100vh;
}

.dp-conter {
	padding-bottom: 40px;
	padding-top: 100px;
}
.dp-hq-header {
	background: #000;
	color: #fff;
}
.dp-hq-header,
.dp-hq-item {
	display: flex;
	align-items: center;
	justify-content: space-around;
	text-align: center;

	height: 72px;
	font-weight: bold;
	font-size: 24px;
}

.dp-hq-item {
	white-space: nowrap;
	font-size: 36px;
	height: 70px;
}

.dp-hq-item > div {
	width: 100%;
	height: 72px;
	line-height: 72px;
}

.dp-hq-pmd {
	font-size: 16px;
	height: 10px;
	padding-right: 20px;
	background: #191c21;
	scrollbar-width: none;
}

.dp-hq-time {
	text-align: right;
	white-space: nowrap;
	margin-top: 10px;
	color: #fff;
	font-size: 40px;
}

.dp-hq-conter {
	/* border-top: 1px solid #fff; */
	/* background: #EE4073; */
	overflow-y: scroll;
	height: calc(100vh - 250px);
	scrollbar-width: none;
	position: relative;
	/* Firefox */
}

.dp-hq-pmd > div::-webkit-scrollbar,
.dp-hq-conter::-webkit-scrollbar {
	display: none;
	/* Safari 和 Chrome */
}

.dp-cj,
.dp-jc,
.dp-zx {
	height: calc(100vh - 160px);
}

.dp-title {
	padding-left: 20px;
	position: fixed;
	display: flex;
	justify-content: space-between;
	top: 0;
	width: 100%;
	background: #8f3024;
	height: 100px;
	line-height: 80px;
	z-index: 1;
}
.dp-title-item {
	line-height: 70px;
	font-weight: bold;
	font-size: 50px;
}
.dp-title-item > div {
	margin: 0 5px;
}
.dp-title-item2 {
	line-height: 20px;
	font-size: 30px;
	margin-top: 20px;
}
.dp-title-item,
.dp-title-item2 {
	text-align: center;
}
.dp-tabbar {
	display: flex;
	align-items: center;
	justify-content: space-around;
	text-align: center;
	position: fixed;
	bottom: 0;
	width: 100%;
	background: #191c21;
	font-size: 18px;
	border-top: 1px solid #fff;
}

.dp-item {
	cursor: pointer;
	width: 100%;
	height: 60px;
	line-height: 40px;
	font-weight: bold;
}
.msg > div {
	font-size: 16px;
	padding-left: 10px;
}
.dqtx {
	width: 100vw;
	height: 100vh;
	background: #fff;
	position: fixed;
	z-index: 99999999;
	color: #ee4073;
	text-align: center;
	padding: 20px 0;
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 30px;
}
.dqtx p {
	margin-top: 20px;
}
/* .tabbar-hover {
	background: #000000;
} */
.jszc {
	bottom: 0;
	text-align: center;
	color: #fff !important;
	width: 100%;
	font-size: 20px;
	position: fixed;
	z-index: 999;
	left: 50%;
	background: #000;
	transform: translate(-50%);
}
@media only screen and (max-width: 767px) {
	.dqtx {
		font-size: 18px;
	}
	.good-name {
		font-size: 16px !important;
	}
	.dp-hq-pmd {
		height: 30px;
		padding: 10px 0;
	}
	.dp {
		height: calc(100vh + 20px) !important;
	}
	.gd {
		font-size: 16px;
		line-height: 20px !important;
		margin-top: 0;
		font-weight: 500;
	}

	.dp-hq-item {
		font-weight: 500;
		font-size: 18px;
		height: auto;
		border-bottom: none !important;
	}
	.dp-hq-item > div {
		height: 50px;
		line-height: 50px;
		border-right: 1px solid rgba(163, 163, 163, 0.5);
	}
	.dp-hq-item > div:last-child {
		padding-top: 10px;
		border-right: none;
	}

	.dp-tabbar {
		background: #fff;
	}
	.dp-item {
		font-size: 16px;
		font-weight: 400;
	}
	/* .tabbar-hover {
		background: #f5f5f5;
	} */
	.dp-hq-header {
		font-weight: bold;
		font-size: 20px;
		height: 50px;
	}
	.dp-hq-time {
		position: absolute;
		top: 52px !important;
		text-align: center;
		line-height: 20px;
		font-size: 12px;
		top: 20px;
		right: 6px;
	}
	.phone_icon {
		display: block;
		float: right;
		padding: 4px;
	}
	.phone_icon img {
		width: 100%;
		height: auto;
	}
	.dp-conter {
		height: 100% !important;
		padding-top: 60px;
		padding-bottom: 20px;
	}
	.dp-hq-conter {
		height: calc(100vh - 120px) !important;
	}
	.dp-title {
		height: 60px;
		padding-left: 5px;
	}
	.dp-title > img {
		padding: 10px;
		padding-left: 0;
	}
	.dp-title-item {
		font-size: 28px;
		line-height: 40px;
	}
	.dp-title-item2 {
		font-size: 16px;
		line-height: 10px;
	}
	.dp-title-item > div {
		margin: 0px;
	}
	.marqueee {
		margin-top: 14px;
	}
	.group-label {
		padding: 0;
		padding-right: 10px;
		font-size: 20px;
	}

	.jiantou {
		margin-left: -15px;
		font-size: 15px;
	}
	.jszc {
		font-size: 16px;
	}
}
</style>
